module.exports = __webpack_public_path__ + "static/media/icon-eye.bfba231b.svg";